import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import AutocompleteTextField from "../AutocompleteTextField/AutoCompleteTextField";
import { CarrierService } from "../../../services/CarrierService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function CarrierDotNumberAutocomplete({
  label,
  title,
  titleSize,
  width,
  selectedOption,
  updateSelectedCarrier,
  disabled,
  error
}) {
  const { instance } = useMsal();
  const [options, setOptions] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { warning } = useContext(AlertContext);

  useEffect(() => {
    updateSelectedCarrier(selectedOption);

    if (!selectedOption) {
      setSearchInput("");
    }
  }, [selectedOption]);

  useEffect(() => {
    if (searchInput.length > 3) {
      const params = {
        ["dotNumber"]: searchInput
      };

      setIsLoading(true);
      CarrierService.FindCarrier(instance, params).then(res => {
        setOptions(res);
        setIsLoading(false);
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    } else {
      setOptions([]);
    }
  }, [searchInput]);

  return (
    <Autocomplete
      id={`autocomplete-${label}`}
      freeSolo
      autoHighlight
      disabled={disabled}
      value={selectedOption}
      onChange={(event, newValue) => {
        updateSelectedCarrier(newValue);
      }}
      options={options}
      filterOptions={(x) => x}
      sx={{
        width: width,
        "& .MuiOutlinedInput-root": {
          padding: "1.5px 39px 1.5px 0 !important",
        }
      }}
      inputValue={searchInput}
      PaperComponent={
        ({ children }) =>
          <Paper sx={{
            backgroundColor: "black_solid.10",
            fontSize: "body1.fontSize",
            fontWeight: "body1.fontWeight",
            boxShadow: "elevation1"
          }}
          >
            {children}
          </Paper>
      }
      onInputChange={(event, newInputValue) => {
        setSearchInput(newInputValue);
      }}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={option =>
        option && `${option.dotNumber}`
      }
      renderInput={(params) =>
        <AutocompleteTextField
          label={label}
          title={title}
          titleSize={titleSize}
          isLoading={isLoading}
          searchInput={searchInput}
          selected={selectedOption}
          params={params}
          error={error}
        />
      }
    />
  );
}

CarrierDotNumberAutocomplete.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  titleSize: PropTypes.string,
  width: PropTypes.string,
  selectedOption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  updateSelectedCarrier: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool
};